import { render, staticRenderFns } from "./minutes.vue?vue&type=template&id=478f7180&scoped=true&"
import script from "./minutes.vue?vue&type=script&lang=js&"
export * from "./minutes.vue?vue&type=script&lang=js&"
import style0 from "./minutes.vue?vue&type=style&index=0&id=478f7180&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f7180",
  null
  
)

export default component.exports